{
 "new": "חדש",
 "engaged": "בשיחה",
 "qualified": "מתאים",
 "booked": "קבע תור",
 "customer": "לקוח",
 "lost": "אבד",
 "AI handling": "ה-AI מטפל",
 "Needs a person": "דרוש נציג",
 "Closed": "סגור",
 "WhatsApp": "וואטסאפ",
 "Messenger": "מסנג׳ר",
 "Instagram": "אינסטגרם",
 "Web chat": "צ׳אט באתר",
 "now": "עכשיו",
 "{n}m": "{n} ד׳",
 "{n}h": "{n} ש׳",
 "{n}d": "{n} י׳",
 "Loading…": "טוען…",
 "Something went wrong": "משהו השתבש",
 "Close": "סגירה",
 "Menu": "תפריט",
  "Intake forms": "טפסי קליטה",
  "Reusable forms and customer responses": "טפסים רב־פעמיים ותשובות לקוחות",
  "Create intake form": "יצירת טופס קליטה",
  "Form title": "כותרת הטופס",
  "Field label": "תווית השדה",
  "Field type": "סוג השדה",
  "Required": "חובה",
  "One option per line": "אפשרות אחת בכל שורה",
  "Remove field": "הסרת שדה",
  "Add field": "הוספת שדה",
  "Save draft": "שמירת טיוטה",
  "View responses": "הצגת תשובות",
  "Publish and share": "פרסום ושיתוף",
  "Archive": "העברה לארכיון",
  "Create personal link": "יצירת קישור אישי",
  "Open form": "פתיחת טופס",
  "Share on WhatsApp": "שיתוף ב־WhatsApp",
  "Share link": "קישור לשיתוף",
  "Thank-you message (optional)": "הודעת תודה (לא חובה)",
  "Shown after a successful submission when no redirect URL is configured. Leave blank for the default message.": "מוצגת לאחר שליחה מוצלחת כאשר לא הוגדרה כתובת הפניה. השאירו ריק להודעת ברירת המחדל."
}
